const getPrescriberFirstName = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber['First Name']) {
    return prescriber['First Name'].toUpperCase();
  }
  if (patient.Prescriber[0]) {
    return patient.Prescriber[0]['First Name'].toUpperCase();
  }
  return null;
};

export default getPrescriberFirstName;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberFirstName.js